module.exports = __webpack_public_path__ + "img/1509518335.f6195169.jpg";